class ProductAddon extends HTMLElement {
  constructor() {
    super();
    this.inputTotal = this.querySelector("[name='total']");
    this.inputMax = this.querySelector("[name='max']");
    this.inputMin = this.querySelector("[name='min']");
    this.displayInputTotal = this.querySelector("span[data-option-total]");
    this.addToCartButton = document.querySelector(
      "form[data-type='add-to-cart-form'] button[type='submit']"
    );
    this.pricingType = this.dataset["bundle"];

    const options = this.querySelectorAll(".product-option__quantity-selector");
    if (options) {
      options.forEach((node) => {
        const mainInputValue = node.querySelector(".quantity-selector-input");
        const buttonMinus = node.querySelector("button[name='minus']");
        const buttonPlus = node.querySelector("button[name='plus']");

        buttonMinus.addEventListener(
          "click",
          this.minus.bind(this, mainInputValue)
        );
        buttonPlus.addEventListener(
          "click",
          this.plus.bind(this, mainInputValue)
        );
      });
    }
    this.checkAddToCart();
  }

  plus(mainInputValue) {
    const value = parseInt(mainInputValue.value);
    const max = parseInt(mainInputValue.max);
    const total = parseInt(this.inputTotal.value);
    console.log(total);
    if (value == max || total == max) return;
    const newValue = value + 1;
    const newTotal = total + 1;
    mainInputValue.value = newValue;
    this.inputTotal.value = newTotal;
    this.displayInputTotal.innerHTML = newTotal;
    this.checkAddToCart();
  }

  checkAddToCart() {
    if (parseInt(this.inputTotal.value) !== parseInt(this.inputMax.value)) {
      this.addToCartButton.setAttribute("disabled", "disabled");
    } else {
      this.addToCartButton.removeAttribute("disabled");
    }
    if (checkProductAvailabilities) {
      checkProductAvailabilities();
    }
  }

  minus(mainInputValue) {
    const value = parseInt(mainInputValue.value);
    const total = parseInt(this.inputTotal.value);
    if (value == 0 || total == 0) return;
    console.log(value);
    console.log(total);
    const newValue = value - 1;
    const newTotal = total - 1;
    this.inputTotal.value = newTotal;
    this.displayInputTotal.innerHTML = newTotal;
    mainInputValue.value = newValue;
    this.checkAddToCart();
  }
}

customElements.define("product-addon", ProductAddon);
